export class Note {
  public _id!: string;
  public title!: string;
  public body!: string;
}
